module.exports = __webpack_public_path__ + "static/img/1483_phase_function_Paper_Points.5487eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1483_phase_function_Paper_Points.png
// module id = iDI8
// module chunks = 0